export { default } from "./AmenitiesSection";
